import type { ReactElement } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/** Shared look for icon-only rail items (nav links, theme toggle): 44px rounded square. Colours follow the sidebar tokens. */
export const sidebarTileClassName =
  'relative flex size-11 items-center justify-center rounded-xl text-sidebar-foreground/55 transition-colors outline-none hover:bg-sidebar-accent hover:text-sidebar-foreground focus-visible:ring-3 focus-visible:ring-sidebar-ring/50'

/** Wraps a rail item so its label appears to the right on hover or keyboard focus. */
export function SidebarTooltip({ label, children }: { label: string; children: ReactElement }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right" sideOffset={10} className="px-2.5 py-1 text-xs font-medium">
        {label}
      </TooltipContent>
    </Tooltip>
  )
}
